import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { memberApplicationRoutes } from '../routes/member-application-routes-list';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class ApplicationCompletedGuardService {

  public memberApplicationRoutes = memberApplicationRoutes;

  constructor(private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('access_token') && localStorage.getItem('user')) {
      let user = new User(JSON.parse(localStorage.getItem('user')!));
      if (!user.member?.isDraft()) {
        return true;
      }
    }
    this.router.navigateByUrl(this.memberApplicationRoutes.member_application.pending_application.index);
    return false;
  }
}
